// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* @description NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).  https://openapi-generator.tech  Do not edit the class manually.
*/
export var CaseContactInformationPurposeType;
(function (CaseContactInformationPurposeType) {
    CaseContactInformationPurposeType[CaseContactInformationPurposeType["UNKNOWN"] = 0] = "UNKNOWN";
    CaseContactInformationPurposeType[CaseContactInformationPurposeType["MAIN"] = 1] = "MAIN";
    CaseContactInformationPurposeType[CaseContactInformationPurposeType["MARKETING"] = 2] = "MARKETING";
    CaseContactInformationPurposeType[CaseContactInformationPurposeType["SALES"] = 3] = "SALES";
    CaseContactInformationPurposeType[CaseContactInformationPurposeType["CUSTOMERSERVICE"] = 4] = "CUSTOMERSERVICE";
    CaseContactInformationPurposeType[CaseContactInformationPurposeType["HOME"] = 5] = "HOME";
    CaseContactInformationPurposeType[CaseContactInformationPurposeType["WORK"] = 6] = "WORK";
    CaseContactInformationPurposeType[CaseContactInformationPurposeType["SEASONAL"] = 7] = "SEASONAL";
    CaseContactInformationPurposeType[CaseContactInformationPurposeType["OTHER"] = 8] = "OTHER";
})(CaseContactInformationPurposeType || (CaseContactInformationPurposeType = {}));
//# sourceMappingURL=caseContactInformationPurposeType.js.map